<template>
  <k-dialog
    @close="cancel"
    :max-width="400"
    :title="action"
    :dataSourceArray="dataSourceArray"
    :selectedIdentity="selectedIdentity"
    :selectedTenant="selectedTenant"
  >
    <form class="k-form" @submit.prevent="save">
      <div style="width: 50vw">
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">User Name</label>

          <div class="col-sm-9">
            <k-input
              type="text"
              :name="'userName'"
              v-model="userInEdit.userName"
              class="form-control"
              required
            ></k-input>
          </div>
        </div>

        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label"> Email</label>
          <div class="col-sm-9">
            <k-input
              :name="'email'"
              class="form-control"
              v-model="userInEdit.email"
              type="email"
              required
            ></k-input>
          </div>
        </div>
        <div
          class="form-group row"
          v-if="reqPassword"
          :style="{ marginBottom: '1rem' }"
        >
          <label class="col-sm-3 text-left col-form-label">Password</label>

          <div class="col-sm-9">
            <k-input
              type="password"
              :name="'password'"
              class="form-control"
              v-model.lazy="userInEdit.password"
              required
            ></k-input>
          </div>
          <p
            class="error px-3 pt-2"
            v-if="
              !$v.userInEdit.password.strongPassword &&
              $v.userInEdit.password.$dirty
            "
          >
            Password needs to have a lowercase and uppercase letter, a number, a
            special character, and be more than 8 characters long.
          </p>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Phone Number
          </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              class="form-control"
              :name="'phoneNumber'"
              v-model="userInEdit.phoneNumber"
              required
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Select Roles :
          </label>
          <div class="col-sm-9">
            <kendo-multiselect
              ref="multiselect"
              :name="'roles'"
              v-model="userInEdit.roles"
              :data-source="dataSourceArray"
              :data-text-field="'roleName'"
              :data-value-field="'roleID'"
              :placeholder="'Select Roles...'"
              class="form-control"
              @change="onChange"
              :validation-message="'Please Select'"
            >
            </kendo-multiselect>
          </div>
        </div>
        <div  v-if="!userInEdit.id" class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Select Tenant :
          </label>
          <div class="col-sm-9">
            <select class="form-control"  
             v-model="userInEdit.tenantID"
             required
            >
            <option v-for="tenant in tenants" :key="tenant.id" :value="tenant.id">
              {{tenant.name}}
            </option>
            </select>
            
          </div>
        </div>
        <div
          v-if="userInEdit.tenant != undefined"
          class="form-group row"
          :style="{ marginBottom: '1rem' }"
        >
          <label class="col-sm-3 text-left col-form-label">
            Selected Tenant
          </label>
          <div class="col-sm-9">
            <p class="form-control">{{ userInEdit.tenant.name }}</p>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label"> Is Active? </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="userInEdit.isActive"
              :messages="messages"
              v-model="userInEdit.isActive"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label"> Enable Two Factor? </label>
          <div class="col-sm-2">
            <kendo-switch
              class="form-control"
              :checked="userInEdit.twoFactorEnabled"
              :messages="messages"
              v-model="userInEdit.twoFactorEnabled"
            ></kendo-switch>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
           SMS Channel Key
          </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              class="form-control"
              :name="'smsChannelKey'"
              v-model="userInEdit.smsChannelKey"
            ></k-input>
          </div>
        </div>
        <div class="form-group row" :style="{ marginBottom: '1rem' }">
          <label class="col-sm-3 text-left col-form-label">
            Email Channel Key
          </label>
          <div class="col-sm-9">
            <k-input
              type="text"
              class="form-control"
              :name="'emailChannelKey'"
              v-model="userInEdit.emailChannelKey"
            ></k-input>
          </div>
        </div>
      </div>
      
      <input type="submit" id="submit-form" class="d-none" />
    </form>

    <div class="d-flex ">
      <button class="k-button col-6" @click="cancel" >Cancel</button>
      <label class="k-button k-primary col-6 mb-0" for="submit-form" tabindex="0"
        >Save</label
      >
    </div>
  </k-dialog>
</template>
<script>
import { Dialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import { NumericTextBox, Input } from "@progress/kendo-vue-inputs";
import { MultiSelect } from "@progress/kendo-dropdowns-vue-wrapper";
import { required } from "vuelidate/lib/validators";
import { Switch } from "@progress/kendo-inputs-vue-wrapper";
import { oidcSettings } from "../../services/store";
import "@progress/kendo-ui/js/kendo.core";
import "@progress/kendo-ui/js/kendo.switch";
import "@progress/kendo-ui/js/kendo.data";
import "@progress/kendo-ui/js/kendo.multiselect";
import DialogContainer from '../Clients/DialogContainer.vue';

export default {
  components: {
    "k-input": Input,
    numerictextbox: NumericTextBox,
    "k-dialog": Dialog,
    "dialog-actions-bar": DialogActionsBar,
    "kendo-multiselect": MultiSelect,
    "kendo-switch": Switch,
    DialogContainer,   

  },
  props: {
    dataItem: Object,
    dialogTitle: String,
    dataSourceArray: Array,
    selectedIdentity: Object,
    selectedTenant: Object,
    tenants:Array,
  },
  data: function () {
    return {
      userInEdit: {
        userName: "",
        email: 0,
        phoneNumber: "",
        password: "",
        roles: [],
        tenantName: "",
        isActive: false,
        tenantName: "",
      },
      base_url: undefined,

      action: "",
      messages: {
        checked: "Yes",
        unchecked: "No",
      },
      multiselectValue: [],
    };
  },
  validations: {
    userInEdit: {
      password: {
        required,
        strongPassword(password) {
          return (
            /[A-Z]/.test(password) &&
            /[a-z]/.test(password) && // checks for a-z
            /[0-9]/.test(password) && // checks for 0-9
            /\W|_/.test(password) && // checks for special char
            password.length >= 8
          );
        },
      },
    },
  },
  created: function () {
    this.action = this.$props.dialogTitle;
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";

    console.log(this.$props.dialogTitle);
    if (this.$props.dataItem) {
      this.userInEdit = this.$props.dataItem;
      console.log(this.userInEdit.roles);
    } else {
      this.userInEdit = {
        userName: "",
        email: "",
        phoneNumber: "",
        password: "",
        roles: [],
        isActive: false,
        tenantName: "",
      };
    }
  },
  mounted: function () {
    console.log(this.$refs);
    var t = this.$refs.multiselect.kendoWidget();
    t.value(this.userInEdit.roles);
    console.log(this.userInEdit.roles);
    console.log(t.value());
  },

  computed: {
    reqPassword() {
      if (this.action == "Add user") {
        return true;
      } else return false;
    },
  },

  methods: {
    
    onSelectTenant() {
      console.log("change",this.userInEdit.tenantID);
    },
    onChange() {
      console.log("changed");
    },
    cancel() {
      this.$emit("cancel");
    },
    save() {
      if (
        Array.isArray(this.userInEdit.roles) &&
        this.userInEdit.roles.length
      ) {
        if (this.userInEdit.roles[0].roleID) {
          this.userInEdit.roles = this.userInEdit.roles.map((role) =>
            this.dataSourceArray.find(
              (roleObject) => roleObject.roleID == role.roleID
            )
          );
        } else {
          this.userInEdit.roles = this.userInEdit.roles.map((role) =>
            this.dataSourceArray.find((roleObject) => roleObject.roleID == role)
          );
        }
      } else {
        alert("Please select a role");
        return;
      }
      if (this.$props.dialogTitle == "Edit user") {
        this.$emit("save");
      } else {
        this.$v.$touch();

        if (!this.$v.$invalid) {
          console.log(this.userInEdit.roles);
          this.$emit("save");
        }
      }
    },
  },
};
</script>
<style scoped>
</style>